"use client";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { ReservedSearchParams } from "../[[...category]]/reserved-params";

export function useUpdateFilters() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  function updateFilter(name: string, value: string | string[] | null) {
    const params = new URLSearchParams(searchParams.toString());

    const persistentParams = ["search"];

    for (const reservedParam of ReservedSearchParams) {
      if (params.has(reservedParam) && !persistentParams.includes(reservedParam)) {
        params.delete(reservedParam);
      }
    }

    // Always delete existing values for this parameter first
    params.delete(name);

    if (value !== null && value !== "" && !(Array.isArray(value) && value.length === 0)) {
      // Append multiple values as separate parameters
      if (Array.isArray(value)) {
        value.forEach(v => params.append(name, v));
      } else {
        params.set(name, value);
      }
    }

    const query = params.toString();
    router.push(query ? `${pathname}?${query}` : pathname, { scroll: false });
  }

  function buildFilterQuery({ name, value }: { name: string, value: string | string[] | null }, currentQuery: string | undefined) {
    const params = new URLSearchParams(currentQuery);

    // Remove pagination params if you add them later
    params.delete("cursor");
    params.delete("page");

    // Always delete existing values for this parameter first
    params.delete(name);

    if (value !== null && value !== "" && !(Array.isArray(value) && value.length === 0)) {
      // Append multiple values as separate parameters
      if (Array.isArray(value)) {
        value.forEach(v => params.append(name, v));
      } else {
        params.set(name, value);
      }
    }

    const query = params.toString();
    return query;
  }

  return { updateFilter, buildFilterQuery };
}
